import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { BookingCheckoutSheet } from '@/features/booking/components/BookingCheckoutSheet';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { useAuth } from '@/features/auth/hooks/useAuth';

function GuideBookingPageContent() {
  const { guideId } = useParams<{ guideId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated, isInitializing } = useAuth();
  const [open, setOpen] = useState(true);

  const context = useMemo(
    () => ({
      guideId: guideId!,
      travelDate: searchParams.get('date') ?? undefined,
      endDate: searchParams.get('endDate') ?? undefined,
      city: searchParams.get('city') ?? undefined,
      travelers: searchParams.get('travelers')
        ? Number(searchParams.get('travelers'))
        : 1,
    }),
    [guideId, searchParams]
  );

  useEffect(() => {
    if (isInitializing) return;
    if (!isAuthenticated) {
      navigate('/', { replace: true, state: { from: window.location.pathname + window.location.search } });
    }
  }, [isAuthenticated, isInitializing, navigate]);

  if (!guideId || isInitializing || !isAuthenticated) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '40vh',
          bgcolor: 'background.default',
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <BookingCheckoutSheet
          open={open}
          onClose={() => {
            setOpen(false);
            navigate(`/guides/${guideId}`, { replace: true });
          }}
          {...context}
        />
      </Container>
    </Box>
  );
}

export function GuideBookingPage() {
  return (
    <ProtectedRoute>
      <GuideBookingPageContent />
    </ProtectedRoute>
  );
}
